<script lang="ts" setup>
// @ts-nocheck - Property 'index' does not exist on type '{ $: ComponentInternalInstance; $data: {}; $props: Partial<{}> & Omit<Readonly<ExtractPropTypes<__VLS_TypePropsToRuntimeProps<PagebuilderAccordionProps>>> & VNodeProps & AllowedComponentProps & ComponentCustomProps, never>; ... 10 more ...; $watch<T extends string | ((...args: any) => any)>(source: T, cb: T extends ...'.
import type { TabLink } from '~/components/tabs/Tabs.vue'

export interface WidgetPagesTabsProps {
    links: TabLink[];
    data: Page[];
    selectLabel: string;
    headingLevel?: string;
}

const props = withDefaults(defineProps<WidgetPagesTabsProps>(), {
    headingLevel: 'h3',
})
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <Tabs
    :select-on-mobile="true"
    type="tertiary"
    direction="vertical"
    tabs-id="WidgetPagesTabs"
    :select-label="props.selectLabel"
    :links="props.links"
  >
    <template
      v-for="(page, index) in props.data"
      :key="index"
      #[`tab-panel-${index}`]
    >
      <article
        class="rounded-4 bg-white box-shadow-1 p-4 p-lg-10 position-sticky top-12"
      >
        <Typo>
          <div class="row">
            <div
              v-if="page.image?.path"
              class="col-12 col-md-4 mb-4 mb-md-8"
            >
              <img
                :src="useSrcSet(page.image.path)?.src"
                :srcset="useSrcSet(page.image.path)?.srcSet"
                sizes="23rem"
                loading="lazy"
                decoding="async"
                width="230"
                class="d-block img-fluid rounded-3"
                alt=""
              >
            </div>
            <div
              v-if="page.perex"
              class="col-12"
              :class="{ 'col-md-8 ps-lg-7': page.image?.path }"
            >
              <Heading
                :level="props.headingLevel"
                class="delta mb-4"
              >
                {{ page.title }}
              </Heading>
              <div
                class="lead-wrapper"
                v-html="$formatTableHtml(page.perex)"
              />
            </div>
          </div>

          <section v-if="page.poistovna">
            <Heading
              :level="props.headingLevel"
              class="delta mb-4"
            >
              {{ page.poistovna.title }}
            </Heading>

            <div
              v-if="page.poistovna.description"
              v-html="
                $formatTableHtml(page.poistovna.description)
              "
            />

            <DocumentsTableSimple
              :data="page.poistovna.data"
              :initial-count="5"
              :caption="page.poistovna.title"
              collapsable
            />
          </section>

          <section v-if="page.sporitelna">
            <Heading
              :level="props.headingLevel"
              class="delta mb-4"
            >
              {{ page.sporitelna.title }}
            </Heading>

            <div
              v-if="page.sporitelna.description"
              v-html="
                $formatTableHtml(page.sporitelna.description)
              "
            />

            <DocumentsTableSimple
              :data="page.sporitelna.data"
              :initial-count="5"
              :caption="page.sporitelna.title"
              collapsable
            />
          </section>

          <div
            v-if="page.description"
            v-html="$formatTableHtml(page.description)"
          />
        </Typo>

        <PostList
          v-if="page.posts && page.posts.length > 0"
          :posts="page.posts"
          :initial-count="5"
          collapsable
        />

        <AwardsList
          v-if="page.awards && page.awards?.length > 0"
          :data="page.awards"
        />
        <VButton
          v-if="page.headline.cta_title"
          :to="page.headline.cta_title.link"
          :label="page.headline.cta_title.text"
          :target="
            page.headline.cta_title.isExternal ? '_blank' : '_self'
          "
          class="mt-4"
          color="primary"
        >
          {{ page.headline.cta_title.text }}
        </VButton>
      </article>
    </template>
  </Tabs>
  <IconsWrapper>
    <IconsSymbolAngleDown />
  </IconsWrapper>
</template>
